// Analytics tracking utility - GA4 + MongoDB

// Get API URL (reuse same logic as App.js)
const getApiUrl = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'sportsguru247.com' || 
        hostname.includes('deploy.emergentcf.cloud') ||
        hostname.includes('sportsguru')) {
      return '/api';
    }
  }
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  return backendUrl ? `${backendUrl}/api` : '/api';
};

const API = getApiUrl();

// Track event to both GA4 and MongoDB
export const trackEvent = async (eventType, eventData = {}) => {
  // Send to GA4
  if (window.gtag) {
    window.gtag('event', eventType, {
      page_path: eventData.page || window.location.pathname,
      element_id: eventData.element_id,
      element_text: eventData.element_text,
      ...eventData.metadata
    });
  }

  // Send to MongoDB
  try {
    await fetch(`${API}/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event_type: eventType,
        page: eventData.page || window.location.pathname,
        element_id: eventData.element_id || null,
        element_text: eventData.element_text || null,
        metadata: eventData.metadata || {}
      })
    });
  } catch (e) {
    // Silent fail - don't break user experience
    console.debug('Analytics tracking error:', e);
  }
};

// Track page view
export const trackPageView = (pagePath) => {
  trackEvent('page_view', { page: pagePath || window.location.pathname });
};

// Track button/link click
export const trackClick = (elementId, elementText, metadata = {}) => {
  trackEvent('click', { element_id: elementId, element_text: elementText, metadata });
};

// Track banner click
export const trackBannerClick = (bannerId, bannerText) => {
  trackEvent('banner_click', { 
    element_id: bannerId, 
    element_text: bannerText,
    metadata: { banner_type: 'promotional' }
  });
};

// Track prediction view
export const trackPredictionView = (matchId, teams) => {
  trackEvent('prediction_view', { 
    element_id: matchId, 
    element_text: teams,
    metadata: { content_type: 'prediction' }
  });
};

// Hook for tracking clicks on elements with data-track attribute
export const initClickTracking = () => {
  document.addEventListener('click', (e) => {
    const target = e.target.closest('[data-track]');
    if (target) {
      const trackId = target.getAttribute('data-track');
      const trackText = target.innerText?.substring(0, 50) || target.getAttribute('data-track-text') || '';
      trackClick(trackId, trackText);
    }
  });
};

export default {
  trackEvent,
  trackPageView,
  trackClick,
  trackBannerClick,
  trackPredictionView,
  initClickTracking
};
